export const capFirstLetter = (stringVal: string): string =>
  stringVal.charAt(0).toUpperCase() + stringVal.toLowerCase().slice(1);
